import * as types from "../service/types";

const InitState = {
  loading: false,
  listApplicationData: "",
  error: "",
};
const ListApplicationReducer = (state = InitState, action) => {
  switch (action.type) {
    case types.LIST_APPLICATION_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.LIST_APPLICATION_SUCCESS:
      return {
        loading: false,
        listApplicationData: action.payload,
        error: "",
      };
    case types.LIST_APPLICATION_ERROR:
      return {
        loader: false,
        listApplicationData: "",
        error: action.error,
      };
    default:
      return state;
  }
};

export default ListApplicationReducer;